/* eslint-disable i18n-scan/no-inline-content */
import { BodyText, Link } from '@paypalcorp/pp-react'
import { merge } from 'lodash-es'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import { getPortalUrl } from 'ppbl/screens/__utils__'
import React, { useEffect } from 'react'
import { CaseTypes, thankYouPageConstants } from 'ppbl/utils/constants'

type Props = {
  applicationType: string
}
const ThankYouPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()
  const portalInfo = data?.applicationMetaData?.portalAccess

  const fptiData = {
    page: `thankYouPage`,
    event_name: FPTI_EVENTS.PAGE.THANK_YOU,
  }

  useEffect(() => {
    clientLogger.info(
      'Thank you page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
    sessionStorage.setItem('mostRecentCompletedPage', 'thank-you')
  }, [])

  const handleContinueToPortalClick = function () {
    trackClick(
      merge(fptiData, {
        component: `continueToPortal_button`,
        link: `continueToPortal_button`,
        applicationId: data?.applicationMetaData?.applicationId,
        event_name: FPTI_EVENTS.CONTINUE_TO_PORTAL_PRESSED,
      }),
    )
    clientLogger.info(
      'Redirecting to Portal Page - Flow Complete',
      data?.applicationMetaData?.applicationId,
    )
    const portalUrl = getPortalUrl(portalInfo, CaseTypes.PENDING_STIPULATIONS)
    window.open(portalUrl, '_self')
  }

  return (
    <>
      <PageMessage
        id="thankYouPage"
        type="checkList"
        onPrimaryAction={handleContinueToPortalClick}
        localization={{
          title: getLocalizedText(`thankYou-page.title`),
          primaryText: getLocalizedText(`thankYou-page.continueBtn`),
          noteText1: interpolate(
            getLocalizedText('thankYou-page.noteText1.text'),
            {
              phone: (
                <Link
                  href={thankYouPageConstants.phoneNumber.tel}
                  size="sm"
                  secondary
                >
                  {thankYouPageConstants.phoneNumber.phone}
                </Link>
              ),
            },
          ),
          noteText2: getLocalizedText('thankYou-page.noteText2.text'),
        }}
      >
        <BodyText className="body__text">
          {getLocalizedText(`thankYou-page.bodyText`)}
        </BodyText>
      </PageMessage>
    </>
  )
}

export default ThankYouPage
